import React, { useState, useEffect, useContext, useCallback } from 'react';
import { useLocation } from "react-router-dom";
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import ModalPop from 'components/sales/modal/modal';
import Images from 'assets/images/imageData';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import CardSection from 'components/sales/cardSection/cardSection';
import './vendor.css';

const PREVIOUS_PR_HEADERS = [
  'PR Number',
  'PR Type',
  'Vendor',
  'Status',
  'PR Amount',
  'Creation Date',
  'View',
];

const VendorAllocation = ({
  getVendorList,
  vendorList,
  allocateVendor,
  getSitePrListing,
  sitePrListData,
  match,
}) => {
  const [siteId, setSiteId] = useState();
  const { baseUrl } = useContext(BaseUrl);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [listData, setListData] = useState([]);
  const [previousPrListData, setPreviousPrListData] = useState([]);
  const [previousPrPageCount, setPreviousPrPageCount] = useState(0);
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [allocateVendorModal, setAllocateVendorModal] = useState(false);
  const [data, setData] = useState('');
  const [previousPrsLoaded, setPreviousPrsLoaded] = useState(false);

  const headers = [
    'Vendor Name',
    'Vendor Code',
    'Active Sites',
    'PR Number',
    'PR Status',
    'Action',
  ];

  const loadPreviousPrs = useCallback(
    async (page = 1) => {
      if (!siteId || !getSitePrListing) return;
      await getSitePrListing({ siteId }, page);
    },
    [siteId, getSitePrListing]
  );

  useEffect(() => {
    setSiteId(match.params.id);
  }, [match.params.id]);

  const prType = searchParams.get('pr_type');

  useEffect(() => {
    if (!siteId || !getVendorList || !getSitePrListing) return;

    let cancelled = false;

    (async () => {
      setIsLoading(true);
      setPreviousPrsLoaded(false);

      try {
        await Promise.all([
          getVendorList(siteId, prType ?? null),
          getSitePrListing({ siteId }, 1),
        ]);
      } finally {
        if (!cancelled) {
          setPreviousPrsLoaded(true);
          setIsLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [siteId, prType, getVendorList, getSitePrListing]);

  useEffect(() => {
    const tableData = [
      'id',
      'name_of_firm',
      'vendor_code',
      'active_sites',
      'pr_no',
      'pr_status_name',
    ];
    const data =
      vendorList &&
      vendorList.list &&
      vendorList.list.length > 0 &&
      vendorList.list.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({
            [key]:
              key === 'pr_no'
                ? vendorList.pr_no
                : key === 'pr_status_name'
                ? vendorList.pr_status_name
                : element[key],
          })),
          {
            Actions:
              Number(element.vendor_code) ===
              Number(vendorList.allocated_vendor_code)
                ? Number(vendorList.boq_generated) === 0
                  ? {
                      name: localization.continueWithBOQ,
                      vendorId: element.id,
                      vendorCode: element.vendor_code,
                      link: `${baseUrl}/manage-vendor/${siteId}/${element.id}/${match.params.pr_sub_type}`,
                      darkButton: true,
                    }
                  : {
                      name: localization.pRCreated,
                      vendorId: element.id,
                      vendorCode: element.vendor_code,
                      darkButton: true,
                      disabled: true,
                    }
                : {
                    name: localization.continueWithBOQ,
                    vendorId: element.id,
                    vendorCode: element.vendor_code,
                    link: `${baseUrl}/manage-vendor/${siteId}/${element.id}/${match.params.pr_sub_type}`,
                    darkButton: true,
                  },
          }
        )
      );
    setListData(data);
  }, [vendorList, baseUrl, siteId, match.params.pr_sub_type]);

  useEffect(() => {
    const tableData = [
      'id',
      'pr_no',
      'pr_type',
      'firm_name',
      'status_text',
      'total_amount',
      'created_at',
    ];

    if (sitePrListData?.data?.length) {
      const rows = sitePrListData.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({
            [key]: key === 'pr_no' ? (element.pr_no ?? element.id) : element[key],
          })),
          {
            view_details: `${baseUrl}/pr-confirmation-details`,
          }
        )
      );
      setPreviousPrListData(rows);
      setPreviousPrPageCount(
        Math.ceil(sitePrListData.total / sitePrListData.per_page)
      );
    } else {
      setPreviousPrListData([]);
      setPreviousPrPageCount(0);
    }
  }, [sitePrListData, baseUrl]);

  const postAllocateVendor = async (val) => {
    const requestData = {
      siteId: siteId,
      vendorId: val,
    };
    setIsLoading(true);
    await allocateVendor(requestData).then(async (response) => {
      if (response) {
        await getVendorList(siteId, prType ?? null);
        setIsLoading(false);
        setIsModal(true);
      }
    });
  };
  const handleModalHide = () => setIsModal(false);

  const handleCheck = (val) => {
    setData(val);
    localStorage.setItem('viewDetail', JSON.stringify(val));
    setAllocateVendorModal(true);
  };

  const handleVendorSumbit = () => {
    setAllocateVendorModal(false);
    (async () => {
      if (
        Number(data.vendorCode) !== Number(vendorList.allocated_vendor_code)
      ) {
        postAllocateVendor(data.vendorId);
      }
    })();
  };

  const onPreviousPrPageChange = async (val) => {
    setIsLoading(true);
    await loadPreviousPrs(val.selected + 1);
    setIsLoading(false);
  };

  const hasPreviousPrs = previousPrListData.length > 0;
  const isPageReady = !isLoading && previousPrsLoaded;

  return (
    <Layout
      title={localization.bOQAssignment}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/site-listing`}
    >
      {isPageReady && (
      <div className="vendor-allocation-page">
        <div className="vendor-previous-prs-section">
          <div className="vendor-previous-prs-header">Previously Raised PRs</div>
          {hasPreviousPrs ? (
            <TableSection
              data={previousPrListData}
              isId={false}
              headers={PREVIOUS_PR_HEADERS}
              pageCount={previousPrPageCount}
              srNo={sitePrListData?.from}
              onPageChange={onPreviousPrPageChange}
              detailList={sitePrListData?.data}
              hideImage
            />
          ) : (
            <p className="vendor-previous-prs-note">
              <strong>Note:</strong> No PRs raised yet for this site.
            </p>
          )}
        </div>

        <div className="vendor-boq-section">
          {vendorList?.isMrfCreated == 0 && match.params.pr_sub_type == 1 ? (
            <CardSection title={localization.fillMrfFirst}>
              <center className="red">Please fill inspection MRF first.</center>
            </CardSection>
          ) : (
            <TableSection
              data={listData}
              headers={headers}
              detailList={vendorList && vendorList.list}
              isId={false}
              handleValue={handleCheck}
              hideImage
            />
          )}
        </div>
      </div>
      )}

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.vendorAllocateSuccess}</h5>
          <Link
            to={`${baseUrl}/manage-vendor/${siteId}`}
            className="btn btn-primary mb-4"
          >
           <div className="continue_btn"> {localization.continue} <img src={Images?.ArrowRight} alt="" /></div>
          </Link>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.conf}
        show={allocateVendorModal}
        handleModalHide={() => {
          setAllocateVendorModal(false);
        }}
        keyboard
        backdrop
      >
        <div className="text-center">
          <h5>{localization.sureAllocateVendor}</h5>
          <div className="button_alignment">
          <Button
            className="btn  button_col btn-primary mb-4"
            onClick={() => {
              handleVendorSumbit();
            }}
          >
            {localization.continue}{' '}
            <img src="../images/arrow-right.png" alt="" />
          </Button>
          <Button
            onClick={() => setAllocateVendorModal(false)}
            className="btn  button_size btn-transparent"
          >
            {localization.cancel} <img src={Images?.ArrowRight} alt="" />
          </Button>
          </div>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default VendorAllocation;
